export const USER_FORM_AVATAR_STYLING = {
  noIconStyling: 'text-4xl pt-4 h-24',
  buttonStyling: 'h-[4.5rem] w-[4.5rem]',
};
